module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAABABAMAAACJoGidAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURUxpcf///////////////////////////////////////////20p1csAAAALdFJOUwCAIN/PEKCQYEBfnU8SZgAAAGtJREFUOMtjYBg8gDEBTUB6G5qC3btRlUjv3o2qJHs3mpIQoMB2ZAFWb6CIALqSjfRQooyuhMl6QJXswlAyAV1JAT4BsBYFNAU78FmL7jA6KMCIhhDaK2BBT3QYyRIj4WIkbYzEj5k9BgMAAFF5e9Oo8WsYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/icon-return.png
// module id = W/6w
// module chunks = 1